import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { ModalService } from '../../../../core/services/modal.service';

interface MedicalRecordHistoryRow {
  date: string;
  summary: string;
}

interface MedicalRecordHistoryModalData {
  title?: string;
  rows?: MedicalRecordHistoryRow[];
}

@Component({
  selector: 'app-medical-record-history-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './medical-record-history-modal.component.html',
})
export class MedicalRecordHistoryModalComponent implements OnInit {
  title = 'Historique';
  rows: MedicalRecordHistoryRow[] = [];

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    const data = ModalDataService.getData() as
      | MedicalRecordHistoryModalData
      | undefined;
    this.title = data?.title ?? 'Historique';
    this.rows = data?.rows ?? [];
  }

  close(): void {
    this.modalService.closeAll();
  }
}
